import dayjs from 'dayjs'

import Api from '@/misc/api'

export default {
  state: {
    logs: {
      totalMatching: 1,
      pageCount: 1,
      logEvents: [],
      shownLogEventId: null,
    },
    prefs: { stayEditions: { seeMoreEventsGrouping: false } },
    stayEditions: { raw:[], formated: [] },
    stayStatusList: [],
    requests: {
      getLogEventsRequest: { fetching: false, error: null, ok: false },
      getStayEditionRequest: { fetching: false, error: null, ok: false },
      getStayStatusListRequest: { fetching: false, error: null, ok: false },
    },
  },
  getters: {
    shownLogEvent: (state) => state.logs.logEvents.find((logEvent) => logEvent.id === state.logs.shownLogEventId),
  },
  mutations: {
    moveLogEventShown(state, move) {
      const currentIndex = state.logs.logEvents.map((event) => event.id).indexOf(state.logs.shownLogEventId)
      const newIndex = Math.min(Math.max(0, currentIndex + move), state.logs.logEvents.length - 1)
      state.logs.shownLogEventId = state.logs.logEvents[newIndex].id
    },
    setShownLogEventId(state, logEventId) {
      state.logs.shownLogEventId = logEventId
    },
    getLogEventsStart(state) {
      state.requests.getLogEventsRequest = { fetching: true, error: null, ok: false }
      state.logs.shownLogEventId = null
      state.logs.logEvents = []
    },
    getLogEventsSuccess(state, logEvents) {
      state.requests.getLogEventsRequest = { fetching: false, error: null, ok: true }
      state.logs.logEvents = logEvents['content']
      state.logs.pageCount = logEvents['_hateoas']['pageCount'] ?? 1
      state.logs.totalMatching = logEvents['_hateoas']['totalMatching'] ?? 0
    },
    getLogEventsError(state, res) {
      state.requests.getLogEventsRequest = { fetching: false, error: res.message, ok: false }
    },
    getStayEditionStart(state) {
      state.requests.getStayEditionRequest = { fetching: true, error: null, ok: false }
      state.stayEditions = { raw:[], formated: [] }
    },
    getStayEditionSuccess(state, stayEditions) {
      state.requests.getStayEditionRequest = { fetching: false, error: null, ok: true }
      state.stayEditions = stayEditions.map((edition) => {
        return {
          ...edition,
          creationDate: dayjs(edition.creationDate),
        }
      })
    },
    getStayEditionError(state, res) {
      state.requests.getStayEditionRequest = { fetching: false, error: res.message, ok: false }
    },
    logsReset(state) {
      state.requests.getStayEditionRequest = { fetching: false, error: null, ok: false }
      state.stayEditions = { raw:[], formated: [] }
      state.stayStatusList = []
      state.requests.getStayStatusListRequest = { fetching: false, error: null, ok: false }
    },
    getStayStatusListStart(state) {
      state.requests.getStayStatusListRequest = { fetching: true, error: null, ok: false }
    },
    getStayStatusListSuccess(state, stayStatusList) {
      state.requests.getStayStatusListRequest = { fetching: false, error: null, ok: true }
      state.stayStatusList = stayStatusList
    },
    getStayStatusListError(state, res) {
      state.requests.getStayStatusListRequest = { fetching: false, error: res.message, ok: false }
    },
    updatePrefs(state, { prefArea, prefKey, prefValue }) {
      state.prefs[prefArea][prefKey] = prefValue
    },
  },
  actions: {
    getLogEvents({ commit }, { pmsiType, earlyLimit, lateLimit, messageContains, responseContains, trigger, page, pageSize }) {
      return Api.post(
        {
          url: '/api/maintenance/logs/log_io',
          body: {
            pmsiType,
            earlyLimit,
            lateLimit,
            messageContains,
            responseContains,
            trigger,
            page: page ?? 1,
            pageSize: pageSize ?? 50,
          },
          startMut: 'getLogEventsStart',
          successMut: 'getLogEventsSuccess',
          errorMut: 'getLogEventsError',
        },
        commit
      )
    },
    getStayEditions({ commit, state }, { pmsiType, pmsiId }) {
      return Api.get(
        {
          url: `/api/maintenance/stay-editions/${pmsiId}?pmsiType=${pmsiType === 'mco' ? 'mco' : 'smr'}&more=${state.prefs.stayEditions.seeMoreEventsGrouping ? 1 : 0}`,
          startMut: 'getStayEditionStart',
          successMut: 'getStayEditionSuccess',
          errorMut: 'getStayEditionError',
        },
        commit
      )
    },
    getStayStatusList({ commit }, { pmsiType, pmsiId }) {
      return Api.post(
        {
          url: `/api/maintenance/${pmsiType}/stay-status/${pmsiId}`,
          startMut: 'getStayStatusListStart',
          successMut: 'getStayStatusListSuccess',
          errorMut: 'getStayStatusListError',
        },
        commit
      )
    }
  }
}
